export default function SkeletonList({ rows = 6, height = "h-16" }: { rows?: number; height?: string }) {
  return (
    <div className="space-y-3" aria-label="Loading">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className={`shimmer-bg rounded-2xl ${height}`} />
      ))}
    </div>
  );
}
